import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const useQualitySummary = (enabled) => {
    const { api } = useAuth();
    const [summary, setSummary] = useState(null);

    const refresh = useCallback(() => {
        api.get('/quality-tasks/my/summary').then(({ data }) => setSummary(data)).catch(() => {});
    }, [api]);

    useEffect(() => {
        if (!enabled) return undefined;
        refresh();
        const interval = setInterval(refresh, 60000);
        window.addEventListener('focus', refresh);
        window.addEventListener('quality-tasks-updated', refresh);
        return () => {
            clearInterval(interval);
            window.removeEventListener('focus', refresh);
            window.removeEventListener('quality-tasks-updated', refresh);
        };
    }, [enabled, refresh]);

    return enabled ? summary : null;
};
